import React from 'react';
import { Header } from '../../components';

const Dashboard = () => (
  <>
    <Header category="Home" title="Dashboard" />
  </>
);
export default Dashboard;
